export default __webpack_public_path__ + "static/media/x.7b050cac.svg";